import { customDispatchedRoutes } from ".front-commerce/customWebModules";

export default customDispatchedRoutes
  .filter(Boolean)
  .reduce((acc, dispatch) => {
    Object.keys(dispatch).forEach((key) => {
      acc[key] = dispatch[key];
    });

    return acc;
  }, {});
